export default "__VITE_ASSET__8824232c__"